import React, { useState } from "react";
import { MdDelete, MdOutlineZoomOutMap } from "react-icons/md";
import FileUploadIcon from "../../../assets/images/folder-open.png";
import DocumentIcon from "../../../assets/images/document.png";
import "../../../style/form.css";
import { useToast } from "../../../ToastContext";
import PreviewModel from "./PreviewModel/PreviewModel";

function ChildOneCloseEyesFile({
  showError,
  childOneCloseEyesFiles,
  setChildOneCloseEyesFiles,
}) {
  const toast = useToast();
  const [isDragging, setIsDragging] = useState(false);
  const ALLOWED_FILE_TYPES = ["image/png", "image/jpg", "image/jpeg"];
  const MAX_FILE_SIZE = 10 * 1024 * 1024;
  const [open, setOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [hover, setHover] = useState(false);
  const [hoverDelete, setHoverDelete] = useState(false);

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const validFiles = selectedFiles.filter(
      (file) => ALLOWED_FILE_TYPES.includes(file.type) && file.size <= MAX_FILE_SIZE
    );

    if (validFiles.length < selectedFiles.length) {
      toast.error("Only PNG, JPG, and JPEG files under 10MB are allowed.", { duration: 7000 });
    }

    const filesWithPreview = validFiles.map((file) => ({
      file: file,
      preview: URL.createObjectURL(file),
    }));

    setChildOneCloseEyesFiles((prevFiles) => [...prevFiles, ...filesWithPreview]);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    const droppedFiles = Array.from(event.dataTransfer.files);

    const validFiles = droppedFiles.filter(
      (file) => ALLOWED_FILE_TYPES.includes(file.type) && file.size <= MAX_FILE_SIZE
    );

    if (validFiles.length < droppedFiles.length) {
      toast.error("Only PNG, JPG, and JPEG files under 10MB are allowed.", { duration: 7000 });
    }

    const filesWithPreview = validFiles.map((file) => ({
      file: file,
      preview: URL.createObjectURL(file),
    }));

    setChildOneCloseEyesFiles((prevFiles) => [...prevFiles, ...filesWithPreview]);
  };

  const handleFileRemove = (indexToRemove) => {
    setChildOneCloseEyesFiles((prevFiles) => {
      const newFiles = prevFiles.filter((_, index) => index !== indexToRemove);
      URL.revokeObjectURL(prevFiles[indexToRemove].preview);
      return newFiles;
    });
  };

  const getFileIcon = (file) => {
    if (!file || !file.type) return DocumentIcon;
    const fileType = file.type.split("/")[0];
    if (fileType === "image") {
      return file.preview;
    }
    return DocumentIcon;
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handlePreview = (selected) => {
    console.log(selected, "selected");
    setSelectedFile(selected);
    setOpen(true);
  };

  return (
    <div style={{ textAlign: "center", width: "100%" }}>
      <div
        className={`file-upload-container ${showError && childOneCloseEyesFiles.length === 0 ? "error-border" : ""
          } ${isDragging ? "dragging" : ""}`}
        onClick={() => document.getElementById("childOneCloseEyesFile").click()}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <img
          src={FileUploadIcon}
          width="30px"
          height="30px"
          alt="Upload Icon"
        />
        <div>
          <span className="upload-heading-text">Drag your file(s) or</span> {""}
          <span className="browse-file-text-align">Browse File</span>
        </div>
        <p className="para-text-upload">Max 10 MB files are allowed</p>
        <span className="para-text-upload">Png Jpg jpeg</span>
      </div>
      <input
        type="file"
        id="childOneCloseEyesFile"
        multiple
        onChange={handleFileChange}
        style={{
          width: "0.1px",
          height: "0.1px",
          opacity: 0,
          overflow: "hidden",
          // position: "absolute",
          zIndex: -1,
        }}
      />
      {showError && childOneCloseEyesFiles.length === 0 && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <p
            style={{
              color: "#FE1D1D",
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: "14px",
              textAlign: "center",
              marginTop: "10px",
            }}
          >
            All fields are required.
          </p>
        </div>
      )}
      <div style={{ maxHeight: "150px", overflowY: "auto" }}>
        {childOneCloseEyesFiles.map((fileObj, index) => (
          <div key={index} className="card-upload-img-align relative">
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src={fileObj.preview}
                width="32px"
                height="32px"
                alt="File Preview"
                style={{ marginRight: "10px", objectFit: "cover" }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <p
                  style={{
                    color: "#000000",
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "14px",
                    margin: 0,
                  }}
                >
                  {fileObj.file ? fileObj.file.name : "Unknown File"}
                </p>
                <p
                  style={{
                    color: "#BABEBE",
                    fontFamily: "Inter",
                    fontWeight: 400,
                    fontSize: "12px",
                    margin: 0,
                    alignItems: "center",
                  }}
                >
                  {fileObj.file ? `${fileObj.file.size} bytes` : ""}
                </p>
                {/* <button
                  className="flex items-end text-black"
                  onClick={() => handlePreview(fileObj)}
                >
                  Preview
                </button> */}
              </div>
            </div>
            <MdOutlineZoomOutMap
              size={24}
              color={hover ? "green" : "#BABEBE"}
              style={{
                cursor: "pointer",
                position: "absolute",
                right: "40px",
              }}
              onClick={() => handlePreview(fileObj)}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
            />
            <MdDelete
              size={24}
              color={hoverDelete ? "red" : "#BABEBE"} 
              style={{ cursor: "pointer" }}
              onClick={() => handleFileRemove(index)}
              onMouseEnter={() => setHoverDelete(true)} 
              onMouseLeave={() => setHoverDelete(false)}  
            />
          </div>
        ))}
      </div>
      <PreviewModel
        isOpen={open}
        onClose={handleClose}
        selectedFile={selectedFile}
      />
    </div>
  );
}

export default ChildOneCloseEyesFile;
